import React, { useState } from "react"
import { Button } from "antd"
import CustomModal from "components/new-stuff/ui/modals/CustomModal"
import { ChevronRightIcon } from "@heroicons/react/24/outline"

const QUESTIONS = [
  {
    question: "What is a workplace?",
    answer:
      "A branch or office that manages its own payroll independently. Each workplace has its own employees, duty locations, and T&A configuration. Only create separate workplaces when each branch processes payroll independently.",
  },
  {
    question: "What is a duty location?",
    answer:
      "A physical site where employees clock in and work. Every workplace has a primary duty location (its own address, auto-created). Secondary duty locations are added for temporary sites not owned by the company — e.g., a security company deploying guards to client premises. Shift plans, geofencing, and scheduling are all configured per duty location.",
  },
  {
    question: "How many duty locations can I create?",
    answer:
      "No limit. Add as many secondary locations as needed. Manage them any time from the Duty Locations tab or during initial setup.",
  },
  {
    question: "What is the purpose of this page?",
    answer:
      "The first screen after clicking Setup — it lets you choose which workplace (branch) to configure. From here you can select, edit, or create workplaces, and create duty locations. It's the entry point before configuring shift plans, locations, and assignments.",
  },
]

const WorkplaceFaqModal: React.FC = () => {
  const [faqModalOpen, setFaqModalOpen] = useState(false)
  const [activeQuestion, setActiveQuestion] = useState<{
    question: string
    answer: string
  }>()

  const openQuestion = (item: { question: string; answer: string }) => {
    setActiveQuestion(item)
    setFaqModalOpen(true)
  }

  const closeQuestion = () => {
    setFaqModalOpen(false)
    // setActiveQuestion(null)
  }

  return (
    <>
      <div className="border-2 border-[#CAD5E2] rounded-md p-3 flex flex-col gap-2">
        <p className="text-sm font-bold text-[#0F172B]">
          Frequently asked questions
        </p>
        <div className="flex flex-nowrap gap-2 overflow-x-auto whitespace-nowrap [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {QUESTIONS.map((q) => (
            <span
              key={q.question}
              role="button"
              tabIndex={0}
              onClick={() => openQuestion(q)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") openQuestion(q)
              }}
              className="shrink-0 h-7 rounded-[6px] border border-dashed border-[#CAD5E2] px-3 py-1 text-xs text-[#0F172B] inline-flex items-center gap-1 cursor-pointer hover:bg-[#F8FAFC]"
            >
              {q.question}
              <ChevronRightIcon className="w-3 h-3 text-[#94A3B8]" />
            </span>
          ))}
        </div>
      </div>

      <CustomModal rootClassName="ta-scope"
        open={faqModalOpen}
        onCancel={closeQuestion}
        title="Glossary / FAQs"
        width={444}
        centered
        footer={null}
      >
        <div className="flex flex-col gap-1">
          <h2 className="text-[#0F172B] font-bold text-[18px]">
            {activeQuestion?.question ?? ""}
          </h2>
          <p className="text-[#62748E] leading-[20px] text-sm">
            {activeQuestion?.answer ?? ""}
          </p>
        </div>
        <div className="mt-8">
          <Button
            onClick={closeQuestion}
            type="default"
            className="w-full h-10 rounded-lg border-2 border-[#E2E8F0] font-semibold text-[#0F172B]"
          >
            Close
          </Button>
        </div>
      </CustomModal>
    </>
  )
}

export default WorkplaceFaqModal
